import { CustomDataBaseModel } from '@seahorse/domain';

export class FileDropModel {
  objectId: string;
  objectType: string;
  objectKey: string;
  object: CustomDataBaseModel;
  files: FileList;
  source?: string;
}
